(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('.faq-item:not([data-bound])').forEach(function(item){
      item.dataset.bound = '1';
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      q.addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        var list = item.closest('.faq-list');
        list.querySelectorAll('.faq-item.open').forEach(function(o){
          o.classList.remove('open');
          o.querySelector('.faq-q').setAttribute('aria-expanded','false');
          o.querySelector('.faq-a').style.maxHeight = null;
        });
        if(!isOpen){
          item.classList.add('open');
          q.setAttribute('aria-expanded','true');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gravur-configurator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('[id^="configCanvas-"]').forEach(function(canvas){
      if(canvas.dataset.built) return;
      canvas.dataset.built = '1';
      var id = canvas.id.replace('configCanvas-','');
      var selectEl = document.getElementById('configSelect-'+id);
      var input = document.getElementById('configInput-'+id);
      var countEl = document.getElementById('configCount-'+id);
      var priceEl = document.getElementById('configPrice-'+id);
      var ctaEl = document.getElementById('configCta-'+id);
      if(!selectEl || !input) return;

      var firstOpt = selectEl.options[0];
      var engraver = window.AG.makeEngraver(canvas, {cssW:900, cssH:700, fontSize:62, wood: firstOpt ? firstOpt.dataset.wood : 'beech', seed:11, initial: input.value, maxLength:25});

      function activateOption(btn){
        engraver.setWood(btn.dataset.wood);
        engraver.setText(input.value);
        if(priceEl) priceEl.childNodes[0].textContent = btn.dataset.price + ' ';
        if(ctaEl && btn.dataset.url) ctaEl.href = btn.dataset.url;
      }
      selectEl.addEventListener('change', function(){
        var opt = selectEl.options[selectEl.selectedIndex];
        if(opt) activateOption(opt);
      });

      var debounce;
      input.addEventListener('input', function(){
        if(countEl) countEl.textContent = input.value.length;
        clearTimeout(debounce);
        debounce = setTimeout(function(){ engraver.setText(input.value || 'Dein Text'); }, 180);
      });

      if(ctaEl){
        ctaEl.addEventListener('click', function(e){
          var url = ctaEl.getAttribute('href');
          if(!url) { e.preventDefault(); return; }
          var sep = url.indexOf('?') > -1 ? '&' : '?';
          ctaEl.setAttribute('href', url.split('?')[0] + sep + 'personalize=' + encodeURIComponent(input.value));
        });
      }
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* hero background film: loaded only on larger screens, never with data-saver or reduced motion;
     until then (or instead) the still frame from the poster stays visible */
  var v = document.querySelector('[data-hero-film]');
  if(!v) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saver = navigator.connection && navigator.connection.saveData;
  var small = window.matchMedia && window.matchMedia('(max-width: 699px)').matches && v.getAttribute('data-mobile') !== 'true';
  if(reduce || saver || small) return;
  function start(){
    if(!v.getAttribute('src')){ v.src = v.getAttribute('data-src'); v.load(); }
    var p = v.play(); if(p && p.catch) p.catch(function(){});
  }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(en){
      if(en[0].isIntersecting) start(); else v.pause();
    }).observe(v);
  } else { start(); }
})();
(function(){
  function boot(){
    var svg = document.getElementById('heroLines');
    if(svg && !svg.dataset.built){
      svg.dataset.built = '1';
      var d = [];
      for(var i=0;i<7;i++){
        var y = 60 + i*90 + Math.sin(i)*12;
        d.push('<path d="M -50 '+y+' C 250 '+(y-40)+', 550 '+(y+40)+', 900 '+(y-20)+' S 1300 '+(y+30)+', 1400 '+y+'" stroke="rgba(217,168,94,'+(0.05+ (i%3)*0.03)+')" stroke-width="1.4" fill="none"/>');
      }
      svg.innerHTML = d.join('');
    }

    var headlineEl = document.getElementById('heroHeadline');
    if(headlineEl && !headlineEl.dataset.built){
      headlineEl.dataset.built = '1';
      var defaultHeading = '';
      var defaultEmphasis = '';
      try { defaultHeading = JSON.parse(headlineEl.dataset.defaultHeading || '""'); } catch(e){}
      try { defaultEmphasis = JSON.parse(headlineEl.dataset.defaultEmphasis || '""'); } catch(e){}
      var defaultHeadingLines = defaultHeading.split('\n');
      var variants = [
        { line1: defaultHeadingLines[0] || '', line2: defaultHeadingLines[1] || '', emphasis: defaultEmphasis },
        { line1: 'Ein Name.', line2: 'Ein Material.', emphasis: 'Für immer.' },
        { line1: 'Aus Holz und Stahl', line2: 'wird', emphasis: 'Erinnerung.' },
        { line1: 'Kleine Worte,', line2: 'große', emphasis: 'Wirkung.' },
        { line1: 'Dein Text.', line2: 'Dein Holz.', emphasis: 'Dein Unikat.' },
        { line1: 'Nicht irgendein', line2: 'Geschenk —', emphasis: 'dein Geschenk.' },
        { line1: 'Von Hand gemacht,', line2: 'für immer', emphasis: 'bewahrt.' },
        { line1: 'Ein Stück Holz.', line2: 'Eine ganze', emphasis: 'Geschichte.' }
      ];
      var pick = variants[Math.floor(Math.random() * variants.length)];
      var line1El = document.createElement('span'); line1El.textContent = pick.line1;
      var line2El = document.createElement('span'); line2El.textContent = pick.line2;
      var emEl = document.createElement('em'); emEl.textContent = pick.emphasis;
      headlineEl.innerHTML = '';
      headlineEl.appendChild(line1El);
      headlineEl.appendChild(document.createElement('br'));
      headlineEl.appendChild(line2El);
      headlineEl.appendChild(document.createTextNode(' '));
      headlineEl.appendChild(emEl);
    }

    var canvas = document.getElementById('heroCanvas');
    if(!canvas || canvas.dataset.built) return;
    canvas.dataset.built = '1';
    var wood = canvas.dataset.wood || 'beech';
    var engraver = window.AG.makeEngraver(canvas, {cssW:640, cssH:420, fontSize:56, wood: wood, seed:3, initial: document.getElementById('heroInput').value, maxLength:25});
    var input = document.getElementById('heroInput');
    var count = document.getElementById('heroCount');
    var debounce;
    input.addEventListener('input', function(){
      count.textContent = input.value.length;
      clearTimeout(debounce);
      debounce = setTimeout(function(){ engraver.setText(input.value || 'Dein Name'); }, 180);
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function(){
  function boot(){
    var toggle = document.getElementById('AddAddressToggle');
    var panel = document.getElementById('AddAddressForm');
    if(toggle && panel && !toggle.dataset.bound){
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', function(){ panel.hidden = !panel.hidden; });
    }
    document.querySelectorAll('.address-delete:not([data-bound])').forEach(function(btn){
      btn.dataset.bound = '1';
      btn.addEventListener('click', function(e){
        if(!window.confirm('Adresse wirklich löschen?')) e.preventDefault();
      });
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function(){
  function boot(){
    var page = document.querySelector('.cart-page');
    if(!page || page.dataset.bound) return;
    page.dataset.bound = '1';
    page.addEventListener('click', function(e){
      var stepBtn = e.target.closest('.qty-btn');
      var removeBtn = e.target.closest('[data-cart-page-remove]');
      if(stepBtn){
        var stepper = stepBtn.closest('[data-cart-page-line]');
        var line = parseInt(stepper.dataset.cartPageLine, 10);
        var valEl = stepper.querySelector('.qty-value');
        var qty = parseInt(valEl.textContent, 10) + (stepBtn.hasAttribute('data-qty-increase') ? 1 : -1);
        if(qty < 0) return;
        window.AG.cart.change(line, qty).then(function(){ window.location.reload(); });
      } else if(removeBtn){
        var idx = parseInt(removeBtn.dataset.cartPageRemove, 10);
        window.AG.cart.change(idx, 0).then(function(){ window.location.reload(); });
      }
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function(){
  function boot(){
    var sortForm = document.getElementById('CollectionSortForm');
    if(sortForm && !sortForm.dataset.bound){
      sortForm.dataset.bound = '1';
      sortForm.querySelector('select').addEventListener('change', function(){
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }
    var filterForm = document.getElementById('CollectionFilterForm');
    if(filterForm && !filterForm.dataset.bound){
      filterForm.dataset.bound = '1';
      filterForm.addEventListener('submit', function(e){
        e.preventDefault();
        var url = new URL(window.location.href);
        var params = new URLSearchParams();
        new FormData(filterForm).forEach(function(value, key){ params.append(key, value); });
        url.search = params.toString();
        window.location.href = url.toString();
      });
    }
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
(function(){
  function boot(){
    var link = document.querySelector('[data-show-recover]');
    var panel = document.getElementById('RecoverPasswordForm');
    if(link && panel && !link.dataset.bound){
      link.dataset.bound = '1';
      link.addEventListener('click', function(e){ e.preventDefault(); panel.hidden = false; panel.querySelector('input').focus(); });
    }
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-partner"]) return;
  try {
    
(function(){
  if(!document.querySelector('.partner-page')) return;
  document.body.classList.add('partner-dark-hero');

  /* tabs (without JS all four panels simply stay visible) */
  document.querySelectorAll('[data-partner-tabs]').forEach(function(root){
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role=tab]'));
    var panels = tabs.map(function(t){ return document.getElementById(t.getAttribute('aria-controls')); });
    root.classList.add('is-enhanced');
    function select(i, focus){
      tabs.forEach(function(t, n){
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[n].hidden = !on;
      });
      if(focus) tabs[i].focus();
    }
    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ select(i); });
      t.addEventListener('keydown', function(e){
        var n = i;
        if(e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if(e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if(e.key === 'Home') n = 0;
        else if(e.key === 'End') n = tabs.length - 1;
        else return;
        e.preventDefault();
        select(n, true);
      });
    });
    select(0);
  });

  /* example calculator */
  document.querySelectorAll('[data-partner-calc]').forEach(function(root){
    var pct = parseFloat(root.getAttribute('data-commission'));
    if(isNaN(pct)) return;
    var orders = root.querySelector('#calc-orders'), value = root.querySelector('#calc-value');
    var fmt = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
    function out(name){ return root.querySelector('[data-out="' + name + '"]'); }
    function update(){
      var o = +orders.value, v = +value.value;
      var month = o * v * pct / 100;
      out('orders').textContent = o;
      out('value').textContent = fmt.format(v);
      out('month').textContent = fmt.format(month);
      out('year').textContent = fmt.format(month * 12);
    }
    orders.addEventListener('input', update);
    value.addEventListener('input', update);
    update();
  });

  /* mobile sticky CTA: visible after the hero, hidden once the form is on screen */
  var sticky = document.querySelector('[data-partner-sticky]');
  var hero = document.querySelector('.partner-hero');
  var form = document.getElementById('partner-kontakt');
  if(sticky && hero && form && 'IntersectionObserver' in window){
    var heroGone = false, formSeen = false;
    function sync(){ sticky.classList.toggle('is-visible', heroGone && !formSeen); }
    new IntersectionObserver(function(e){ heroGone = !e[0].isIntersecting; sync(); }).observe(hero);
    new IntersectionObserver(function(e){ formSeen = e[0].isIntersecting; sync(); }, { threshold: .15 }).observe(form);
  }

  if(/[?&]contact_posted=true/.test(location.search)){
    var f = document.getElementById('PartnerForm');
    if(f && f.scrollIntoView) f.scrollIntoView({ block: 'center' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-withdrawal"]) return;
  try {
    
(function(){
  var form = document.getElementById('WithdrawalForm');
  var KEY = 'ag-withdrawal';
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function stamp(d){
    var off = -d.getTimezoneOffset(), sign = off >= 0 ? '+' : '-', a = Math.abs(off);
    return d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds()) + ' (UTC' + sign + pad(Math.floor(a/60)) + ':' + pad(a%60) + ')';
  }
  /* success view: show what was sent (kept only in this browser tab) */
  var success = document.getElementById('WithdrawalSuccess');
  if(success){
    success.focus();
    var summary = document.getElementById('WithdrawalSummary'), data = null;
    try { data = JSON.parse(window.sessionStorage.getItem(KEY) || 'null'); } catch(e){}
    if(summary && data){
      var rows = [['Referenz', data.ref], ['Gesendet', data.time], ['Name', data.name], ['Bestellnummer / Vertrag', data.order], ['Umfang', data.scope], ['Artikel', data.items]];
      rows.forEach(function(r){
        if(!r[1]) return;
        var dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = r[0]; dd.textContent = r[1]; summary.appendChild(dt); summary.appendChild(dd);
      });
      summary.hidden = false;
    }
    var printBtn = document.getElementById('WithdrawalPrint');
    if(printBtn) printBtn.addEventListener('click', function(){ window.print(); });
    return;
  }
  if(!form) return;
  var ref = document.getElementById('WithdrawalRef');
  var clientTime = document.getElementById('WithdrawalClientTime');
  var submit = document.getElementById('WdSubmit');
  var partial = document.getElementById('WdPartial');
  var itemsField = document.getElementById('WdItemsField');
  var items = document.getElementById('WdItems');

  /* one reference per page load: a second click or a resend of the same form carries the same reference, so duplicates are easy to spot */
  var now = new Date();
  ref.value = 'WID-' + now.getFullYear() + pad(now.getMonth()+1) + pad(now.getDate()) + '-' + Math.random().toString(36).slice(2, 8).toUpperCase();

  function syncScope(){
    var isPartial = partial && partial.checked;
    itemsField.hidden = !isPartial;
    items.required = !!isPartial;
    items.setAttribute('aria-required', isPartial ? 'true' : 'false');
  }
  Array.prototype.forEach.call(form.querySelectorAll('input[name="contact[Umfang]"]'), function(r){ r.addEventListener('change', syncScope); });
  syncScope();

  var sending = false;
  form.addEventListener('submit', function(e){
    if(sending){ e.preventDefault(); return; }
    /* required fields (browser validation is off so that the messages stay consistent) */
    var firstBad = null;
    ['WdName','WdOrder','WdEmail'].concat(items.required ? ['WdItems'] : []).forEach(function(id){
      var f = document.getElementById(id);
      var bad = !f.value.trim() || (f.type === 'email' && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.value.trim()));
      f.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if(bad && !firstBad) firstBad = f;
    });
    if(firstBad){ e.preventDefault(); firstBad.focus(); return; }
    sending = true;
    submit.disabled = true; submit.textContent = 'Wird gesendet …';
    var t = new Date(); clientTime.value = stamp(t);
    var scope = form.querySelector('input[name="contact[Umfang]"]:checked');
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify({
        ref: ref.value, time: stamp(t), name: document.getElementById('WdName').value.trim(),
        order: document.getElementById('WdOrder').value.trim(), scope: scope ? scope.value : '', items: items.value.trim()
      }));
    } catch(err){}
    /* if the page is still here after 20 s the request did not go through: re-enable so nothing is lost */
    window.setTimeout(function(){ sending = false; submit.disabled = false; submit.textContent = 'Widerruf bestätigen'; }, 20000);
  });
  var errors = document.getElementById('WithdrawalErrors');
  if(errors){ errors.setAttribute('tabindex', '-1'); errors.focus(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  function boot(){
    var form = document.getElementById('PdpForm');
    var isPilot = !!document.getElementById('PdpWorkshopCta');

    if(isPilot){
      /* pilot products: only the variant pills (if any) affect the Werkstatt CTA link + price display */
      var cta = document.getElementById('PdpWorkshopCta');
      var variantsScript = document.getElementById('PdpPilotVariantsJSON');
      var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
      var priceCurrent = document.querySelector('#PdpPrice .pdp-price-current');
      var priceCompare = document.querySelector('#PdpPrice .pdp-price-compare');

      function currentSelections(){
        var selections = [];
        document.querySelectorAll('.pdp-option').forEach(function(optionEl){
          var pos = parseInt(optionEl.dataset.optionPosition, 10);
          var active = optionEl.querySelector('.pdp-option-pill.active');
          selections[pos-1] = active ? active.dataset.optionValue : null;
        });
        return selections;
      }
      function findVariant(selections){
        if(!variants) return null;
        return variants.find(function(v){
          return [v.option1, v.option2, v.option3].slice(0, selections.length).every(function(val, i){
            return val === selections[i];
          });
        }) || null;
      }
      function applyVariant(variant){
        if(!variant || !cta) return;
        var url = new URL(cta.href, window.location.origin);
        url.searchParams.set('variant', variant.id);
        cta.href = url.toString();
        if(priceCurrent && window.AG) priceCurrent.textContent = window.AG.formatMoney(variant.price);
        if(priceCompare){
          if(window.AGShowCompare && variant.compare_at_price && variant.compare_at_price > variant.price){
            priceCompare.textContent = window.AG.formatMoney(variant.compare_at_price);
            priceCompare.hidden = false;
          } else { priceCompare.hidden = true; }
        }
      }
      document.querySelectorAll('.pdp-option-pill').forEach(function(btn){
        btn.addEventListener('click', function(){
          var group = btn.closest('.pdp-option-values');
          Array.prototype.forEach.call(group.children, function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          var label = btn.closest('.pdp-option').querySelector('[data-option-value]');
          if(label) label.textContent = btn.dataset.optionValue;
          if(variants) applyVariant(findVariant(currentSelections()));
        });
      });
    }

    if(!form || form.dataset.built) { bootRecommendations(); return; }
    form.dataset.built = '1';

    var canvas = document.getElementById('PdpCanvas');
    var input = document.getElementById('PdpPersonalization');
    var counter = document.getElementById('PdpCharCount');
    var errorEl = document.getElementById('PdpPersonalizationError');
    var formError = document.getElementById('PdpFormError');
    var addBtn = document.getElementById('PdpAddToCart');
    var addLabel = document.getElementById('PdpAddToCartLabel');
    var inStockLabel = addLabel ? addLabel.textContent : '';
    var maxChars = parseInt(input ? input.getAttribute('maxlength') : 25, 10);

    var params = new URLSearchParams(window.location.search);
    var prefill = params.get('personalize');
    if(prefill && input) input.value = prefill.slice(0, maxChars);

    var engraver = canvas ? window.AG.makeEngraver(canvas, {cssW:900, cssH:700, fontSize:62, wood: canvas.dataset.wood, seed:17, initial: input ? input.value : '', maxLength: maxChars}) : null;

    function updateCounter(){
      if(counter && input) counter.textContent = input.value.length;
    }
    updateCounter();

    if(input){
      var debounce;
      input.addEventListener('input', function(){
        updateCounter();
        if(errorEl) errorEl.hidden = true;
        clearTimeout(debounce);
        debounce = setTimeout(function(){ if(engraver) engraver.setText(input.value); }, 160);
      });
    }

    /* simple engraving (tag "gravur-text"): schematic text preview in the chosen font */
    var fontSel = document.getElementById('PdpFont');
    var prevEl = document.getElementById('PdpPreviewText');
    var line2El = document.getElementById('PdpLine2');
    function renderPreview(){
      if(!prevEl) return;
      var opt = fontSel ? fontSel.options[fontSel.selectedIndex] : null;
      if(opt){
        prevEl.style.fontFamily = opt.getAttribute('data-family');
        prevEl.style.fontWeight = opt.getAttribute('data-weight');
        prevEl.style.fontStyle = opt.getAttribute('data-style');
      }
      var t1 = input ? input.value.trim() : '';
      var t2 = line2El ? line2El.value.trim() : '';
      prevEl.textContent = '';
      var a = document.createElement('div');
      a.textContent = t1 || prevEl.getAttribute('data-placeholder');
      prevEl.appendChild(a);
      if(t2){
        var b = document.createElement('div');
        b.className = 'l2';
        b.textContent = t2;
        prevEl.appendChild(b);
      }
      prevEl.classList.toggle('is-empty', !t1);
    }
    if(prevEl){
      [input, line2El].forEach(function(el){ if(el) el.addEventListener('input', renderPreview); });
      if(fontSel) fontSel.addEventListener('change', renderPreview);
      renderPreview();
    }

    var qtyStepper = document.getElementById('PdpQtyStepper');
    var qtyInput = document.getElementById('PdpQuantity');
    if(qtyStepper && qtyInput){
      qtyStepper.addEventListener('click', function(e){
        var btn = e.target.closest('.qty-btn');
        if(!btn) return;
        var val = parseInt(qtyInput.value, 10) || 1;
        val += btn.hasAttribute('data-qty-increase') ? 1 : -1;
        if(val < 1) val = 1;
        qtyInput.value = val;
      });
    }

    document.querySelectorAll('.pdp-thumb').forEach(function(btn){
      btn.addEventListener('click', function(){
        var mainImg = document.getElementById('PdpMainImage');
        if(mainImg) mainImg.src = btn.dataset.mediaSrc;
      });
    });

    var variantsScript = document.getElementById('PdpVariantsJSON');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
    var variantIdInput = document.getElementById('PdpVariantId');
    var priceCurrent = document.querySelector('#PdpPrice .pdp-price-current');
    var priceCompare = document.querySelector('#PdpPrice .pdp-price-compare');

    function currentSelections(){
      var selections = [];
      document.querySelectorAll('.pdp-option').forEach(function(optionEl){
        var pos = parseInt(optionEl.dataset.optionPosition, 10);
        var active = optionEl.querySelector('.pdp-option-pill.active');
        selections[pos-1] = active ? active.dataset.optionValue : null;
      });
      return selections;
    }

    function findVariant(selections){
      if(!variants) return null;
      return variants.find(function(v){
        return [v.option1, v.option2, v.option3].slice(0, selections.length).every(function(val, i){
          return val === selections[i];
        });
      }) || null;
    }

    function applyVariant(variant){
      if(!variant) return;
      if(variantIdInput) variantIdInput.value = variant.id;
      if(priceCurrent) priceCurrent.textContent = window.AG.formatMoney(variant.price);
      if(priceCompare){
        if(window.AGShowCompare && variant.compare_at_price && variant.compare_at_price > variant.price){
          priceCompare.textContent = window.AG.formatMoney(variant.compare_at_price);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if(addBtn){
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? inStockLabel : window.AGStrings.soldOut;
      }
    }

    document.querySelectorAll('.pdp-option-pill').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('.pdp-option-values');
        Array.prototype.forEach.call(group.children, function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var label = btn.closest('.pdp-option').querySelector('[data-option-value]');
        if(label) label.textContent = btn.dataset.optionValue;
        if(variants) applyVariant(findVariant(currentSelections()));
      });
    });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(formError) formError.hidden = true;
      if(input && input.value.trim() === ''){
        if(errorEl) errorEl.hidden = false;
        input.focus();
        return;
      }
      var formData = new FormData(form);
      var items = [{
        id: parseInt(formData.get('id'), 10),
        quantity: parseInt(formData.get('quantity'), 10) || 1,
        properties: {}
      }];
      formData.forEach(function(value, key){
        var match = key.match(/^properties\[(.+)\]$/);
        if(match && String(value).trim() !== '') items[0].properties[match[1]] = value;
      });

      addBtn.disabled = true;
      var originalLabel = addLabel.textContent;
      addLabel.textContent = '…';

      window.AG.cart.add(items).then(function(){
        addLabel.textContent = originalLabel;
        addBtn.disabled = false;
        window.AG.cart.open();
      }).catch(function(err){
        addLabel.textContent = originalLabel;
        addBtn.disabled = false;
        if(formError){ formError.textContent = err.message || window.AGStrings.cartError; formError.hidden = false; }
      });
    });

    bootRecommendations();
  }

  function bootRecommendations(){
    var recoEl = document.getElementById('ProductRecommendations');
    if(recoEl && recoEl.dataset.url && !recoEl.dataset.built){
      recoEl.dataset.built = '1';
      fetch(recoEl.dataset.url)
        .then(function(res){ return res.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.getElementById('ProductRecommendations');
          if(inner && inner.innerHTML.trim() !== ''){
            recoEl.innerHTML = inner.innerHTML;
            window.AG.initReveal(recoEl);
            window.AG.initTilt(recoEl);
          }
        })
        .catch(function(){ /* recommendations are a nice-to-have; fail silently */ });
    }
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('canvas[data-mat]').forEach(function(c){
      if(c.dataset.built) return;
      c.dataset.built = '1';
      var ctx = c.getContext('2d');
      var wood = window.AG.WOODS[c.dataset.wood] || window.AG.WOODS.beech;
      var g = window.AG.seededGrain(50 + (+c.dataset.seed||0), 300, 300, 10);
      window.AG.drawBoard(ctx, 300, 300, wood, g);
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-scroll"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('.story[id^="storySection-"]').forEach(function(sectionEl){
      if(sectionEl.dataset.built) return;
      sectionEl.dataset.built = '1';
      var id = sectionEl.id.replace('storySection-','');
      var wood = sectionEl.dataset.storyWood || 'oak';
      var text = sectionEl.dataset.storyText || 'Anna & Tom';
      var textStack = document.getElementById('storyTextStack-'+id);
      var dotsWrap = document.getElementById('storyDots-'+id);
      var indexLabel = document.getElementById('storyIndex-'+id);
      var stageCount = textStack ? textStack.children.length : 0;
      var storyCanvas = document.getElementById('storyCanvas-'+id);
      var sCtx = storyCanvas ? storyCanvas.getContext('2d') : null;
      var sGrain = window.AG.seededGrain(21, 900, 750, 18);
      var woodDef = window.AG.WOODS[wood] || window.AG.WOODS.oak;

      function drawStage(stage, localProgress){
        if(!sCtx) return;
        window.AG.drawBoard(sCtx, 900, 750, woodDef, sGrain);
        if(stage>=1){
          var reveal = stage===1 ? localProgress : 1;
          window.AG.drawEngravedText(sCtx, 900, 750, text, stage>=2 ? 1 : reveal*0.999, 78);
        }
        if(stage>=3){
          sCtx.save();
          sCtx.globalAlpha = 0.9;
          sCtx.strokeStyle = 'rgba(217,168,94,.55)';
          sCtx.lineWidth = 2;
          window.AG.roundRect(sCtx, 40,40,820,670, 40);
          sCtx.stroke();
          sCtx.restore();
        }
      }
      if(sCtx) drawStage(0,0);

      function renderStaticFallback(){
        var wrap = document.getElementById('storyStatic-'+id);
        if(!wrap) return;
        wrap.querySelectorAll('canvas').forEach(function(c){
          var stage = +c.dataset.staticStage;
          var cx = c.getContext('2d');
          var g = window.AG.seededGrain(21+stage, 900, 560, 14);
          window.AG.drawBoard(cx, 900, 560, woodDef, g);
          if(stage>=1) window.AG.drawEngravedText(cx, 900, 560, text, stage>=2?1:0.5, 62);
        });
      }

      var useScrollytelling = !window.AG.reduceMotion;
      var pinWrap = document.getElementById('storyPinWrap-'+id);
      if(useScrollytelling && pinWrap){
        var ticking = false;
        function onScroll(){
          if(ticking) return; ticking = true;
          requestAnimationFrame(function(){
            var rect = pinWrap.getBoundingClientRect();
            var total = pinWrap.offsetHeight - window.innerHeight;
            var progress = (-rect.top) / Math.max(total,1);
            progress = Math.max(0, Math.min(1, progress));
            var raw = progress * stageCount;
            var stage = Math.min(stageCount-1, Math.floor(raw));
            var local = raw - stage;
            Array.prototype.forEach.call(textStack.children, function(el,i){ el.classList.toggle('active', i===stage); });
            if(dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function(el,i){ el.classList.toggle('active', i===stage); });
            if(indexLabel) indexLabel.textContent = 'Kapitel 0'+(stage+1)+' / 0'+stageCount;
            drawStage(stage, local);
            ticking = false;
          });
        }
        window.addEventListener('scroll', onScroll, {passive:true});
      } else if(pinWrap){
        pinWrap.style.display = 'none';
        var staticEl = document.getElementById('storyStatic-'+id);
        if(staticEl){ staticEl.style.display = 'block'; renderStaticFallback(); window.AG.initReveal(staticEl); }
      }
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){
    document.querySelectorAll('[id^="wallScroll-"]').forEach(function(el){
      if(el.dataset.built) return;
      el.dataset.built = '1';
      var isDown=false, startX, scrollLeft;
      el.addEventListener('pointerdown', function(e){ isDown=true; el.classList.add('dragging'); startX=e.pageX; scrollLeft=el.scrollLeft; });
      window.addEventListener('pointerup', function(){ isDown=false; el.classList.remove('dragging'); });
      el.addEventListener('pointermove', function(e){ if(!isDown) return; el.scrollLeft = scrollLeft - (e.pageX-startX); });
    });
  }
  if(window.AG){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();
})();
